"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DtoFileUploadSchema = exports.DropboxObjectFileUploadSchema = exports.GoogleDriveTargetObjectFileUploadSchema = exports.GoogleDriveSourceObjectFileUploadSchema = exports.S3ObjectFileUploadSchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.S3ObjectFileUploadSchema = joi_1.default.object({
    service: joi_1.default.string().allow('s3').required(),
    config: joi_1.default.object({
        accessKeyId: joi_1.default.string().required(),
        secretAccessKey: joi_1.default.string().required(),
        region: joi_1.default.string().required()
    }).required(),
    item: joi_1.default.object({
        Bucket: joi_1.default.string().required(),
        Key: joi_1.default.string().required(),
        ContentType: joi_1.default.string().required(),
        StorageClass: joi_1.default.string().required()
    }).required()
}).meta({ className: 'S3ObjectFileUpload' });
exports.GoogleDriveSourceObjectFileUploadSchema = joi_1.default.object({
    service: joi_1.default.string().allow('gdrive').required(),
    config: joi_1.default.object({
        email: joi_1.default.string().required(),
        key: joi_1.default.string().required(),
        scopes: joi_1.default.array().items(joi_1.default.string()).required(),
        subject: joi_1.default.string().required()
    }),
    item: joi_1.default.object({
        fileId: joi_1.default.string().required()
    }).required()
}).meta({ className: 'GoogleDriveObjectFileUpload' });
exports.GoogleDriveTargetObjectFileUploadSchema = joi_1.default.object({
    service: joi_1.default.string().allow('gdrive').required(),
    config: joi_1.default.object({
        email: joi_1.default.string().required(),
        key: joi_1.default.string().required(),
        scopes: joi_1.default.array().items(joi_1.default.string()).required(),
        subject: joi_1.default.string().required()
    }),
    item: {
        path: joi_1.default.string().required(),
        folderId: joi_1.default.string().required()
    }
}).meta({ className: 'GoogleDriveTargetObjectFileUpload' });
exports.DropboxObjectFileUploadSchema = joi_1.default.object({
    service: joi_1.default.string().allow('dropbox').required(),
    config: joi_1.default.object({
        token: joi_1.default.string().required()
    }).required(),
    item: joi_1.default.object({
        path: joi_1.default.string().required(),
        mode: joi_1.default.string().required()
    }).required()
}).meta({ className: 'DropboxObjectFileUpload' });
exports.DtoFileUploadSchema = joi_1.default.object({
    source: joi_1.default.alternatives(exports.S3ObjectFileUploadSchema, exports.GoogleDriveSourceObjectFileUploadSchema).required(),
    destination: joi_1.default.alternatives(exports.S3ObjectFileUploadSchema, exports.GoogleDriveTargetObjectFileUploadSchema, exports.DropboxObjectFileUploadSchema).required()
}).meta({ className: 'DtoFileUpload' });
//# sourceMappingURL=DtoFileUploadSchema.js.map